module.exports = __webpack_public_path__ + "static/media/press_tvjc.0c6ffd10.jpg";